import {POObject} from '@obj-models/POObject';
import {POPerson} from '@obj-models/POPerson';
import {PORequest} from '@obj-models/PORequest';

export class POActivePersons extends POObject {
  static type = 'ActivePersons';

  id = 0;
  type = POActivePersons.type;
  person: POPerson | number = null;
  request: PORequest | number = null;
  fileId: number = null;
  fileName: string = null;
}
